import React from "react";

import { Typography } from "@/components/Typography";
import { Form } from "@/components/Form";

import { QREditorContext } from "@/contexts/QREditorContext";

import { applyQRFormDefaultValues, onBindClick } from "@/utils/formHelper";
import {
  omittedValues,
  onBindImage,
  onBindSocialNetworks,
  onBindThemePicker,
} from "@/utils/qrEditorHelper";

import { qrBusinessValidation } from "@/utils/validators/qr-business";

import { QREditorContextProps, QRProps } from "@/contexts/QREditorContext/types";
import { BusinessHours } from "@/components/BusinessHours/types";
import { Icon_Facility } from "@/types/qr";
import { QRBusinessProps } from "./types";

import { NAMESPACES } from "@/internals/constants/namespaces";
import { useTranslation } from "react-i18next";
import "./styles.scss";

export const QRBusiness = ({ data }: QRBusinessProps) => {
  const { t } = useTranslation(NAMESPACES.VALIDATIONS);
  const { qrData, setQrData } = React.useContext<QREditorContextProps<"business">>(QREditorContext);

  const [qrBusinessData, setQrBusinessData] = React.useState<QRProps<"business">>(qrData);
  const [renderForm, setRenderForm] = React.useState(false);

  const dataBusinessWithDefaultValues = applyQRFormDefaultValues(data, qrData.data);

  onBindImage(
    dataBusinessWithDefaultValues,
    "qrBusinessInformationLogo",
    omittedValues(qrData.data)
  );
  onBindThemePicker(
    dataBusinessWithDefaultValues,
    "qrBusinessThemePicker",
    omittedValues(qrData.data)
  );
  onBindSocialNetworks(
    dataBusinessWithDefaultValues,
    "qrBusinessSocials",
    "socialNetworks",
    omittedValues(qrData.data)
  );

  onBindClick(
    dataBusinessWithDefaultValues,
    "facilitiesPicker",
    (selectedOptions: Icon_Facility[]) =>
      setQrData(
        {
          ...qrData,
          data: { ...qrData.data, facilities: selectedOptions },
        },
        omittedValues(qrData.data)
      )
  );

  onBindClick(dataBusinessWithDefaultValues, "businessHours", (hours: BusinessHours) =>
    setQrData(
      {
        ...qrData,
        data: { ...qrData.data, businessHours: hours },
      },
      omittedValues(qrData.data)
    )
  );

  const onUpdateState = ({ field, value }) => {
    if (field === "file" || field == "") return;
    setQrData(
      {
        ...qrData,
        data: {
          ...qrData.data,
          [field]: value,
        },
      },
      omittedValues(qrData.data)
    );
  };

  React.useEffect(() => {
    setQrBusinessData(qrData);
  }, [qrData]);

  React.useEffect(() => {
    setQrData({ ...qrBusinessData, isValidForm: renderForm });
  }, [renderForm]);

  return (
    <div className="qr-business">
      <Typography
        Tag="p"
        size="xl"
        classname="u-bold u-spacing-5"
      >
        {data.title}
      </Typography>
      <Form
        fields={dataBusinessWithDefaultValues}
        schema={qrBusinessValidation(data, t)}
        onWatchFields={({ field, value }) => onUpdateState({ field, value })}
        isFormValid={(isValidForm) => setRenderForm(isValidForm)}
      />
    </div>
  );
};
